define([
	'internal_util/Logger',
	'internal_util/Util',
	'internal_util/UiUtil',
	'model/Error',
	'view/canvas/ArrowButtonCanvas',
	'amdi18n-loader?!view/nls/ErrorView_strings',
	'lib/jquery'
], function (
	Logger,
	Util,
	UiUtil,
	Error,
	ArrowButtonCanvas,
	Strings,
	jQuery
) {
	'use strict';

	/**
	 * ErrorView class
	 */
	return function () {
		var _arrowButton = new ArrowButtonCanvas(),
			_view;

		_view = (function () {
			var content = jQuery(
				'<div id="skIdS_error-container" class="alert alert-warning">' +
					'<span id="skIdS_error-header"></span>' +
					'<div id="skIdS_error-content-container">' +
						'<hr class="skIdS_error-content-delimiter">' +
						'<button type="button" id="skIdS_error-report-button" class="btn btn-warning">' +
							Strings.report_button_text +
						'</button>' +
						'<p id="skIdS_error-content-header">' + Util.toHtml(Strings.report_header) + '</p>' +
						'<div id="skIdS_error-user-input">' +
							'<input id="skIdS_error-user-input-name" type="text" placeholder="' + Strings.your_name + '" maxLength="100" />' +
							'<input id="skIdS_error-user-input-email" type="email" placeholder="' + Strings.your_email + '" maxLength="100" />' +
							'<textarea id="skIdS_error-user-input-information" placeholder="' + Strings.more_information + '" maxLength="5000"></textarea>' +
						'</div>' +
						'<p id="skIdS_error-content-footer">' + Util.toHtml(Strings.report_footer) + '</p>' +
						'<hr class="skIdS_error-content-delimiter">' +
						'<p id="skIdS_error-content"></p>' +
					'</div>' +
				'</div>');

			content.find('#skIdS_error-header')
					.after(jQuery(_arrowButton.get()).attr('id', 'skIdS_error-button'));

			content.find('#skIdS_error-button').on('click', function () {
				_arrowButton.turn();

				content.find('#skIdS_error-content-container').animate({
					height: 'toggle'
				}, 'fast', function () {
					UiUtil.scrollTo(content);
				});
			});

			return content;
		})();


		// public methods

		this.get = function () {
			return _view;
		};

		this.update = function (error) {
			var $header = _view.find('#skIdS_error-header'),
				$reportButton = _view.find('#skIdS_error-report-button');

			$header.empty();

			if (error instanceof window.Error) {
				$header.append(decodeURI(error.message));
			} else if (error instanceof Error) {
				if (error.dataIsMessage()) {
					$header.append(decodeURI(error.data()));
				} else {
					$header.append(decodeURI(error.message()));

					if (Util.isValidString(error.data())) {
						$header.append(': ');
						$header.append(decodeURI(error.data()));
					}
				}
			} else {
				$header.append('NO ERROR MESSAGE');
			}

			_view.find('#skIdS_error-content').empty().append(Util.toHtml(Logger.getReport()));

			$reportButton.prop('disabled', false);

			$reportButton.off().on('click', function () {
				var self = this,
					name = _view.find('#skIdS_error-user-input-name').val(),
					email = _view.find('#skIdS_error-user-input-email').val(),
					information = _view.find('#skIdS_error-user-input-information').val();

				jQuery(this).text(Strings.sending_report).prop('disabled', true);

				Logger.uploadReport(name, email, information, function () {
					jQuery(self).text(Strings.report_sent);

					_view.find('#skIdS_error-user-input').children().prop('disabled', true);
				}, function () {
					jQuery(self).text(Strings.report_not_sent).prop('enabled', true);
				});
			})
		};
	};
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/view/ErrorView.js
// module id = 97
// module chunks = 1